export default "__VITE_PUBLIC_ASSET__e75ac6bf__"